import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Button, Center, Link, Spinner, Table, Text } from '@chakra-ui/react';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { gql } from '@src/lib/gql';
import { startups3Url } from '@src/lib/startups-url';
import moment from 'moment';
import React from 'react';
type BillingStatementListProps = {
  subscriptionId: string;
};
export const BillingStatementList = props => {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($subscriptionId: String!) {
        subscription(subscriptionId: $subscriptionId) {
          id
          statements {
            id
            billingStatementId
            billingStatementId
            customerCompanyName

            customerFirstName
            customerLastName
            issuedAt
            paidAt
            paidInCents
            platform
            platformIdentifier
            refundedAt
            refundedInCents
            settledAt
            status
            totalInCents
            items {
              id
              amountInCents
              description
              effectiveDate
              title
              type
              status
              paymentMethodType
              paymentMethodBrand
              paymentMethodMaskedId
            }
            events {
              id
              amountInCents
              description
              effectiveDate
              title
              type
              status
              paymentMethodType
              paymentMethodBrand
              paymentMethodMaskedId
            }
          }
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.subscriptionId) {
    t1 = {
      variables: {
        subscriptionId: props.subscriptionId
      }
    };
    $[1] = props.subscriptionId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = useQuery(t0, t1);
  if (query.error) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center padding="1em"><Text>An error has occurred.</Text></Center>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (query.loading || !query.data) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center padding="1em"><Spinner /></Center>;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== query.data.subscription.statements) {
    t2 = query.data.subscription.statements || [];
    $[5] = query.data.subscription.statements;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const statements = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Table.Header textAlign="left"><Table.Row><Table.ColumnHeader>Statement ID</Table.ColumnHeader><Table.ColumnHeader>Issue Date</Table.ColumnHeader><Table.ColumnHeader>Amount Billed</Table.ColumnHeader><Table.ColumnHeader>Settled Date</Table.ColumnHeader><Table.ColumnHeader>Details/Receipt</Table.ColumnHeader></Table.Row></Table.Header>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props.subscriptionId || $[9] !== statements) {
    let t5;
    if ($[11] !== props.subscriptionId) {
      t5 = statement => <Table.Row key={statement.id}><Table.Cell>{statement.billingStatementId}</Table.Cell><Table.Cell>{statement.issuedAt ? moment(statement.issuedAt).format("LL") : "N/A"}</Table.Cell><Table.Cell>${(statement.totalInCents / 100).toFixed(2)}</Table.Cell><Table.Cell>{statement.settledAt ? moment(statement.settledAt).format("LL") : "N/A"}</Table.Cell><Table.Cell><Button asChild={true} variant="outline"><NextLink target="_blank" href={startups3Url(`/billing/subscriptions/${props.subscriptionId}/statements/${statement.billingStatementId}`)}>View Statement</NextLink></Button></Table.Cell></Table.Row>;
      $[11] = props.subscriptionId;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = statements.map(t5);
    $[8] = props.subscriptionId;
    $[9] = statements;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <Table.ScrollArea><Table.Root size="sm">{t3}<Table.Body>{t4}</Table.Body></Table.Root></Table.ScrollArea>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <hr />;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Text paddingY="1.5em" size="xsmall" textAlign="center">{"Need Help? Contact us at"}{" "}<Link href="mailto:support@startups.com" variant="underline">support@startups.com</Link></Text>;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5) {
    t8 = <Box>{t5}{t6}{t7}</Box>;
    $[17] = t5;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};